import PollingBox from 'root/startup-view/community/content/posts-browser/polling-box';
import HTStartupEvent from 'root/startup-view/community/content/posts-browser/ht-startup-event';
import SingleProducerMeeting from 'root/startup-view/community/content/posts-browser/single-producer-meeting';
import SingleProducerMeetingViewer from 'root/startup-view/community/content/posts-browser/single-producer-meeting/viewer';
import SingleProducerMeetingStreamer from 'root/startup-view/community/content/posts-browser/single-producer-meeting/streamer';
import HTVideo from 'root/startup-view/community/content/posts-browser/ht-video';

class CustomElementsManager {

  constructor() {

    this.elementConfigurations = [{
      name: 'polling-box',
      element: PollingBox
    }, {
      name: 'ht-single-producer-meeting',
      element: SingleProducerMeeting
    }, {
      name: 'ht-single-producer-meeting-viewer',
      element: SingleProducerMeetingViewer
    }, {
      name: 'ht-single-producer-meeting-streamer',
      element: SingleProducerMeetingStreamer
    }, {
      name: 'ht-startup-event',
      element: HTStartupEvent
    }, {
      name: 'ht-video',
      element: HTVideo
    }];

  }

  initialize() {

    const elementConfigurations = this.elementConfigurations;

    for (let elementConfiguration of elementConfigurations) {

      try {

        customElements.define(elementConfiguration.name, elementConfiguration.element);

      } catch (exception) {

        console.error(exception);

      }

    }

  }

}

export default CustomElementsManager;